
import './App.css';
import LandingColumnDate from './pages/landing-column-date/LandingColumnDate';

import MahutiPaymentPage from './pages/mahuti-payment-page/MahutiPaymentPage';
import { Route, Routes, useLocation } from 'react-router-dom';
import PaymentSuccess from './pages/mahuti-payment-page/PaymentSuccess';
import LandingPage from './pages/landing-page/LandingPage';
import LandingProduct from './pages/landing-product-item/LandingProduct';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProductsSF } from './utils/sfUtils';
import { PAGES, PAGES_ARRAY, PREFIX_PATH, setFinishLocalStorageTimeOut } from './utils/GlobalParams';
import PaymentFailed from './pages/mahuti-payment-page/PaymentFailed';
import { setInteralMode, setProducts, setlpName, setlpParams } from './store/MahutiReducer';
import { checkTimestemp, clearAll } from './utils/orderUtils';
import { getLocalStoragKey } from './store/mahutiLocalStorage';

// import 'bootstrap/dist/css/bootstrap.min.css'


function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search)
  const isIntenrnal = params.get('internal_web')== "true";
  const [productsSF, setProductsSF] = useState([]);
  const [isLPLoading, setLPLoading] = useState(true)
  const [landingPageParams, setLandingPageParams] = useState(undefined);
  const ref = useRef(true);
  const [errorMessageHead, setErrorMessageHead] = useState(undefined)
  const [multiLanding, setMultiLanding] = useState('')
  const pathArray = location.pathname.split('/')
  const store = useSelector(state => state.reducer);
  const skipButtonRef = useRef(null);
  const contrastTogglerRef = useRef(null);


  useEffect(() => {
    dispatch(setInteralMode(isIntenrnal));
    if (ref.current) {
        if(location.pathname === "/tickets" || location.pathname === "/tickets/") {
            window.location.href = `${PREFIX_PATH}/holidays`
        }

        ref.current = false;
        init()
    }
  }, [])

  useEffect(() => {
    let isFirstTab = true;
  
    const handleTabs = (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
  
        if (isFirstTab) {
          // First Tab - focus contrast toggler
          const contrastToggler = contrastTogglerRef.current;
          if (contrastToggler) {
            contrastToggler.focus();
          }
          isFirstTab = false;
        } else {
          // Second Tab - focus skip button
          const skipButton = skipButtonRef.current;
          if (skipButton) {
            skipButton.focus();
            skipButton.classList.add('focused');
            // Remove event listener after second tab
            document.removeEventListener('keydown', handleTabs);
          }
        }
      }
    };
  
    // Add event listener when URL changes
    document.addEventListener('keydown', handleTabs);
  
    // Reset isFirstTab and remove previous listener when URL changes
    return () => {
      isFirstTab = true;
      document.removeEventListener('keydown', handleTabs);
    };
  }, [location.pathname]); // Dependency on location.pathname will cause effect to re-run on URL change
  const handleSkipButtonBlur = () => {
    if (skipButtonRef.current) {
      skipButtonRef.current.classList.remove('focused');
    }
  };

  const goToContent = () => {
    // Find the main content container by ID
    const targetElement = document.getElementById('main-title') ? document.getElementById('main-title') : document.getElementById('main-content');
  
    if (targetElement) {
      // Scroll to the element
      document.getElementById('main-title') ? window.scrollTo(0, targetElement.offsetHeight) : window.scrollTo(0, targetElement.offsetTop);
      
      // Set focus for screen readers
      targetElement.setAttribute('tabindex', '-1');
      targetElement.focus();
      
      // Remove tabindex after focus (cleanup)
      targetElement.addEventListener('blur', function onBlur() {
        targetElement.removeAttribute('tabindex');
        targetElement.removeEventListener('blur', onBlur);
      });
  
      // Remove 'focused' class from button after use
      if (skipButtonRef.current) {
        skipButtonRef.current.classList.remove('focused');
      }
    }
  }

  const init = () => {
    let landingP = lpTest()
    getProductsSF(landingP)
    .then(res => {
        setProductsSF(res.data.products);
        setLandingPageParams(res.data.lp);
        dispatch(setlpParams(res.data.lp));
        dispatch(setProducts(res.data.products));
        setLPLoading(false);
        checkIfTimerRuns()

        let lpName = res.data.lp.lpName;
        if(lpName && lpName != 'parents_and_kids_2'){
          setMultiLanding('/' + lpName)
          dispatch(setlpName(lpName))
        }else{
          dispatch(setlpName(false))
        }
    })
    .catch(err => {
      // setErrorMessageHead(err.message); 
      // setLPLoading(false); 
      window.location.href = 'https://www.mahuti.co.il/404'
    });
  }
  
  const checkIfTimerRuns = () => { /* If countDown does't running, and there are items in the cart -> Clear the cart! */
      let localTimestemp = getLocalStoragKey('countDownTimestemp')
      let TimerSecounds = localTimestemp && checkTimestemp(localTimestemp, false)
      if(!TimerSecounds && store.selectedActivities.length > 0){
        console.log('clear')
        clearAll(dispatch)
      }
  }

  const lpTest = () => {
    let length = pathArray?.length

    if(length === 2){
      return false
    }else{
      if(length > 2){
        if(PAGES_ARRAY.includes(pathArray[2])){
          return false
        }else{
          return pathArray[2]
        }
      }else{
        return false
      }
    }
  }

  return (
    <div className="App">
      <button 
          ref={skipButtonRef}
          className="sr-only-focusable moveToMainContentBtn"
          onClick={() => goToContent()}
          onBlur={handleSkipButtonBlur}
          onKeyDown={(e) => e.key === 'Enter' && goToContent()}
          aria-label="דלג לתוכן הראשי"
          type="button">
          דלג לתוכן הראשי 
      </button>
      <Routes>
        <Route path={`${PREFIX_PATH}/*`} element={<LandingPage contrastTogglerRef={contrastTogglerRef} productsSF={productsSF} landingPageParams={landingPageParams} errorMessageHead={errorMessageHead} isLPLoading={isLPLoading}/>} />  
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.DATE_FLOW}`} element={<LandingColumnDate contrastTogglerRef={contrastTogglerRef} landingPageParams={landingPageParams} errorMessageHead={errorMessageHead} />} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.ACTIVITY_FLOW}`} element={<LandingProduct contrastTogglerRef={contrastTogglerRef} landingPageParams={landingPageParams} errorMessageHead={errorMessageHead} />} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.ACTIVITY_FLOW}/:id`} element={<LandingProduct contrastTogglerRef={contrastTogglerRef} landingPageParams={landingPageParams} errorMessageHead={errorMessageHead} />} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.PAYMENT_PAGE}`} element={<MahutiPaymentPage contrastTogglerRef={contrastTogglerRef}/>} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.PAYMENT_PAGE}/:id`} element={<MahutiPaymentPage contrastTogglerRef={contrastTogglerRef}/>} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.PAYMENT_ON_SUCCESS}`} element={<PaymentSuccess />} />
        <Route path={`${PREFIX_PATH}${multiLanding}/${PAGES.PAYMENT_ON_FAILED}`} element={<PaymentFailed />} />
      </Routes> 
    </div>
  );
}


export default App;